export default __webpack_public_path__ + "static/media/file-cabinet.08f7bd42.png";